var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_577_163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.56543,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_577_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1857 21L13.8802 14.7C13.3798 15.1 12.8043 15.4167 12.1537 15.65C11.5032 15.8833 10.8109 16 10.0769 16C8.25869 16 6.72002 15.371 5.46093 14.113C4.20117 12.8543 3.57129 11.3167 3.57129 9.5C3.57129 7.68333 4.20117 6.14567 5.46093 4.887C6.72002 3.629 8.25869 3 10.0769 3C11.8952 3 13.4342 3.629 14.6939 4.887C15.953 6.14567 16.5826 7.68333 16.5826 9.5C16.5826 10.2333 16.4658 10.925 16.2323 11.575C15.9987 12.225 15.6818 12.8 15.2815 13.3L21.5869 19.6L20.1857 21ZM10.0769 14C11.328 14 12.3916 13.5627 13.2677 12.688C14.1431 11.8127 14.5809 10.75 14.5809 9.5C14.5809 8.25 14.1431 7.18733 13.2677 6.312C12.3916 5.43733 11.328 5 10.0769 5C8.82585 5 7.76226 5.43733 6.88617 6.312C6.01074 7.18733 5.57303 8.25 5.57303 9.5C5.57303 10.75 6.01074 11.8127 6.88617 12.688C7.76226 13.5627 8.82585 14 10.0769 14Z",
    fill: "#C9C3DB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.78139eb4416e3c29f55e105d6f51d5d8.svg";
export { ForwardRef as ReactComponent };